import { Axios } from "@lib";
import type { ChecklistAnswerGeneralRequest } from "../types";

export const checklistAnswerGeneral = async (
	payload: ChecklistAnswerGeneralRequest
) => {
	const { answerId, ...body } = payload;

	const { data } = await Axios.put(
		`/api/checklist/answer/${answerId}/general`,
		body
	);

	return data;
};
